import ajax from '@/utils/ajax';
import { Message } from 'vhtml-ui';
import i18n from '@/i18n';
const checkIndustry = async (params) => {
    const res = await ajax.gatewayPost('/v1/basic/corp/corp/checkIndustry', params)
    .catch((e) => {
        Message.error(e.message || i18n.t('网络故障，请稍后再试'));
    });
    if (res && res.code === 0) return true;
    return false;
};
const verifyCode = async (params) => {
    const res = await ajax.post('/mng/account/contacts/checkCorpPhoneVerifyCode', params)
    .catch((err) => {
        Message.error(err.message || i18n.t('网络故障，请稍后再试'));
    });
    if (res && res.data?.res === 1) {
        return true;
    }
    Message.error(i18n.t('验证码错误'));
    return false;
};

export {
    checkIndustry,
    verifyCode,
};
